import React, { memo } from 'react'

export default memo(() => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6C12.2688 6 6 12.2676 6 19.9994C6 27.7312 12.2682 33.9988 20 33.9988C27.7324 33.9988 34 27.7312 34 19.9994C34 12.2676 27.7324 6 20 6Z"
      fill="#23A4DE"
    />
    <path
      d="M20 6C12.2688 6 6 12.2676 6 19.9994C6 27.7312 12.2682 33.9988 20 33.9988C27.7324 33.9988 34 27.7312 34 19.9994C34 12.2676 27.7324 6 20 6ZM20 10.186C22.5582 10.186 24.6312 12.2596 24.6312 14.8166C24.6312 17.3742 22.5582 19.4472 20 19.4472C17.443 19.4472 15.37 17.3742 15.37 14.8166C15.37 12.2596 17.443 10.186 20 10.186ZM19.9969 30.3386C17.4455 30.3386 15.1087 29.4094 13.3062 27.8714C12.8672 27.4969 12.6138 26.9477 12.6138 26.3715C12.6138 23.7783 14.7126 21.7028 17.3065 21.7028H22.6947C25.2892 21.7028 27.38 23.7783 27.38 26.3715C27.38 26.9483 27.1279 27.4963 26.6882 27.8708C24.8864 29.4094 22.549 30.3386 19.9969 30.3386Z"
      fill="white"
    />
  </svg>
))
